<div class="container">
  <div class="row center">
    <div class="col col-50 white">
      @if (!error) {
        <app-spinner
          [display]="true"
          [class]="'spinner-container'"
          [messageToDisplay]="'Completing sign-in...'"
        ></app-spinner>
      }
      @if (error) {
        <p role="alert">{{ error }}</p>
      }
      @if (error) {
        <a mat-flat-button routerLink="/auth/login">Try again</a>
      }
    </div>
  </div>
</div>
